import {GA4InteractionType} from "../../../../analytics/ga4/types/interaction";

export enum ProductCardType {
    PRODUCT = "Product",
    RECIPE = "Recipe"
};

export interface IProductCard {
    type: ProductCardType,
    image: {
        src: string;
        alt: string;
    };
    hoverImage?: {
        src?: string;
        alt?: string;
    };
    title: string;
    subtitle?: string;
    text: string;
    link: string;
    product?: object;
    hasProductPrice?: boolean;
    hasProductFooter?: boolean;
    hasRecipeFooter?: boolean;
    isFavorite?: boolean;
    tags?: IProductCardTags | Array<IRecipeCardTag>;
    componentType?: GA4InteractionType;
}

interface IProductCardTags {
    applications?: Array<ITag>;
    benefits?: Array<ITag>;
    other?: Array<ITag>;
}

interface ITag {
    label: string; 
    properties: {color: string}; 
    queryParams: {tag: string}; 
    url: string; 
}

interface IRecipeCardTag {
    title: string;
    path?: string;
    color?: string;
}
